import { makeAutoObservable } from "mobx";

export type MenuCommand = {
  id: string;
  name: string;
  icon?: React.ReactNode;
  onSelect: () => void;
  isDisabled?: boolean;
};

export class CommandMenuStore {
  private commandsMap = new Map<string, MenuCommand>();

  isOpen = false;

  filterQuery = "";

  constructor() {
    makeAutoObservable<typeof this, "commandsMap">(this, { commandsMap: false });
  }

  addCommand(command: MenuCommand) {
    this.commandsMap.set(command.id, command);
    return () => this.removeCommand(command.id);
  }

  removeCommand(id: string) {
    this.commandsMap.delete(id);
  }

  closeDialog() {
    this.isOpen = false;
    this.filterQuery = "";
  }

  openDialog() {
    this.isOpen = true;
  }

  toggleDialog() {
    this.isOpen = !this.isOpen;
  }

  selectCommand(command: MenuCommand) {
    command.onSelect();
    this.closeDialog();
  }

  setFilterQuery(newFilterQuery: string) {
    this.filterQuery = newFilterQuery;
  }

  get commands() {
    const sortedCommands = Array.from(this.commandsMap.values()).sort((a, b) =>
      a.name.toLowerCase() > b.name.toLowerCase() ? 1 : -1,
    );

    return this.filterQuery
      ? sortedCommands.filter((command) =>
          command.name
            .toLowerCase()
            .replace(/\s+/g, "")
            .includes(this.filterQuery.toLowerCase().replace(/\s+/g, "")),
        )
      : sortedCommands;
  }
}
